/**
 * What a plan is called once the app is running on it.
 *
 * "Starter" is the entry tier's name on the way IN — it is the one paid plan
 * the creation page offers, and that is the only screen where the word does any
 * work. The plan itself is shared CPU, exactly like the two above it, so
 * everywhere that describes an app which already has a plan calls it what it
 * is: Shared.
 *
 * Only the name comes back. The size belongs to the columns and the spec line
 * beside it, where it is labelled — printed into the name as well, it was the
 * copy with no heading over it.
 *
 * Its own module so that both halves of the Plan screen can read it without
 * importing each other.
 */
export const planDisplayName = (plan?: { name: string }): string =>
  plan?.name === 'Starter' ? 'Shared' : plan?.name || '';

/**
 * A plan's size in its own units — "0.5 vCPU · 512 MB · 100 GB transfer" —
 * for the quiet line a checkout puts under the plan's name. What is not set on
 * the plan is left out rather than written as zero.
 *
 * Here because every checkout writes it: the Plan section, the Upgrade from
 * Free, the creation wizard and the pending-payment card. Four copies of three
 * unit rules is how one of them ends up saying "1024 MB".
 */
export const planCheckoutSpec = (plan?: { maxCPU?: number, maxRAM?: number, transferLimit?: number }): string =>
  plan
    ? [
        plan.maxCPU ? `${plan.maxCPU} vCPU` : undefined,
        typeof plan.maxRAM === 'number' ? (plan.maxRAM >= 1024 ? `${plan.maxRAM / 1024} GB` : `${plan.maxRAM} MB`) : undefined,
        typeof plan.transferLimit === 'number' && plan.transferLimit > 0
          ? `${plan.transferLimit >= 1000 ? `${plan.transferLimit / 1000} TB` : `${plan.transferLimit} GB`} transfer`
          : undefined,
      ].filter(Boolean).join(' · ')
    : '';
